import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { withRouter } from "../utils/withRouter";
import { ShieldAlert, Home } from "lucide-react";
import { checkRouteAccess } from "../utils/routePermissions";
import "../styles/RouteGuard.css";

const REDIRECT_SECONDS = 8;

/**
 * Root-level guard: wraps the whole <Switch> and enforces the same permission
 * matrix as the sidebar menu. Blocked URLs show an in-app message and
 * auto-redirect to the home view.
 */
const RouteGuard = ({ role, type, category, location, history, children }) => {
  const verdict = checkRouteAccess(role, type, category, location.pathname);
  const blocked = !verdict.allowed;
  const [secondsLeft, setSecondsLeft] = useState(REDIRECT_SECONDS);

  useEffect(() => {
    if (!blocked) return undefined;
    setSecondsLeft(REDIRECT_SECONDS);
    const interval = setInterval(() => setSecondsLeft((s) => s - 1), 1000);
    return () => clearInterval(interval);
  }, [blocked, location.pathname]);

  useEffect(() => {
    if (blocked && secondsLeft <= 0) history.replace("/");
  }, [blocked, secondsLeft, history]);

  if (!blocked) return children;

  return (
    <div className="rgd-wrap">
      <div className="rgd-card">
        <div className="rgd-icon">
          <ShieldAlert size={28} />
        </div>
        <h2 className="rgd-title">Acceso restringido</h2>
        <p className="rgd-text">
          Tu usuario no tiene permisos para acceder a esta página. Si crees que
          se trata de un error, contacta con tu administrador.
        </p>
        <div className="rgd-actions">
          <Link to="/" className="rgd-btn rgd-btn--primary">
            <Home size={16} />
            Ir al inicio
          </Link>
        </div>
        <div className="rgd-countdown">
          Volverás al inicio en {Math.max(secondsLeft, 0)}s
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  role: state.auth.role,
  type: state.auth.type,
  category: state.auth.category,
});

export default withRouter(connect(mapStateToProps)(RouteGuard));
